<p-button
  [label]="label()"
  [loading]="loading()"
  [disabled]="disabled() || loading()"
  [severity]="severity()"
  [size]="size()"
  (onClick)="onClick()">
</p-button>
